import cn from 'classnames'
import { useTranslations } from 'next-intl'
import { ComponentProps, useMemo } from 'react'
import { getRefinementsConfig } from '../config/refinements.config'
import { RefinementWrapper } from './RefinementWrapper'
import { RefinementsMenuItem } from './RefinementsMenuItem'
import { RefinementsMenuRange } from './RefinementsMenuRange'

type RefinementsMenuProps = ComponentProps<'div'>

export function RefinementsMenu(props: RefinementsMenuProps) {
  const t = useTranslations('SearchRefinements')
  const { lists, ranges } = useMemo(() => getRefinementsConfig(t), [t])

  return (
    <div {...props} className={cn('flex flex-wrap gap-4', props.className)}>
      {lists.map((refinement) => (
        <RefinementWrapper
          key={refinement.attribute}
          refinement={refinement}
          Component={RefinementsMenuItem}
        />
      ))}
      {ranges.map((refinement) => (
        <RefinementWrapper
          key={refinement.attribute}
          refinement={refinement}
          Component={RefinementsMenuRange}
        />
      ))}
    </div>
  )
}
